<div class="quote-step8-quote-step4-1 animation-fadein" [ngClass]="rootClassName">
  <div class="quote-step8-desktop-menu2-default">
    <div class="quote-step8-component1">
      <span class="quote-step8-text"><span>By BAC Financial</span></span>
      <div class="quote-step8-group"></div>
      <div class="quote-step8-group01"></div>
    </div>
    <div class="quote-step8-frame77">
      <span class="quote-step8-text02"><span>Nosotros</span></span>
      <span class="quote-step8-text04"><span>BENEFICIOS</span></span>
      <span class="quote-step8-text06"><span>Planes</span></span>
      <span class="quote-step8-text08"><span>ASEGURADOS</span></span>
    </div>
  </div>

  <div class="container-fluid">

    <div class="row justify-content-center">
      <div class="col-12 d-flex justify-content-center pt-3">
        <div class="row d-inline-flex">
          <div class="col px-0">
            <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
          </div>
          <div class="col d-flex px-0">
            <div class="separator-blue"></div>
          </div>
          <div class="col px-0">
            <img [attr.alt]="vectoralt" [attr.src]="vectorfilled" />
          </div>
          <div class="col d-flex px-0">
            <div class="separator-blue"></div>
          </div>
          <div class="col px-0">
            <img [attr.alt]="vectoralt" [attr.src]="vectorfilled" />
          </div>
          <!-- <div class="col d-flex px-0">
            <div class="separator-white"></div>
          </div>
          <div class="col px-0">
            <img [attr.alt]="vectoralt" [attr.src]="vectorfilled" />
          </div>
          <div class="col d-flex px-0">
            <div class="separator-white"></div>
          </div>
          <div class="col px-0">
            <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
          </div> -->
        </div>
      </div>
      <div class="col-12 d-flex justify-content-center pt-2">
        <div class="row d-inline-flex">
          <div class="col px-0">
            <span class="letter-style-simulate-steps-grey">Cotizar</span>
          </div>
          <div class="col d-flex px-0">
            <div class="separator-letter-transparent"></div>
          </div>
          <div class="col px-0">
            <span class="letter-style-simulate-steps-grey">Customizar</span>
          </div>
          <div class="col d-flex px-0">
            <div class="separator-letter-transparent"></div>
          </div>
          <div class="col px-0">
            <span class="letter-style-simulate-steps-blue">Pagar</span>
          </div>
          <!-- <div class="col d-flex px-0">
            <div class="separator-letter-transparent"></div>
          </div>
          <div class="col px-0">
            <span class="letter-style-simulate-steps-grey">Pago</span>
          </div>
          <div class="col d-flex px-0">
            <div class="separator-letter-transparent"></div>
          </div>
          <div class="col px-0">
            <span class="letter-style-simulate-steps-grey">Certificado</span>
          </div> -->
        </div>
      </div>
    </div>

    <div class="row p-4 pb-0">
      <div class="col-12 text-center DesK,P4,Regular,16 text-bold">
        Coloque los datos de su tarjeta para proceder con su certificado.
      </div>
    </div>

    <!-- <div class="row pb-3">
      <div class="col-12 d-flex justify-content-center flex-column flex-lg-row">

        <form [formGroup]="stepSevenForm" novalidate
          class="p-4 form-general-style col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
          <div class="form-group">
            <label for="cardHolderName" class="label-form-style">Nombre del titular de la tarjeta</label>
            <input type="text" class="form-control input-form-full-space" formControlName="cardHolderName"
              id="cardHolderName">
          </div>
          <div class="form-group">
            <label for="cardNumber" class="label-form-style">Número de tarjeta</label>
            <input type="text" class="form-control input-form-full-space" formControlName="cardNumber" id="cardNumber">
          </div>

          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label for="cardExpirationMonth" class="label-form-style">Mes</label>
                <select class="p-dropdown" formControlName="cardExpirationMonth" id="cardExpirationMonth">
                  <option selected="true" [value]="1">Enero</option>
                  <option [value]="2">Febrero</option>
                  <option [value]="3">Marzo</option>
                  <option [value]="4">Abril</option>
                  <option [value]="5">Mayo</option>
                  <option [value]="6">Junio</option>
                  <option [value]="7">Julio</option>
                  <option [value]="8">Agosto</option>
                  <option [value]="9">Septiembre</option>
                  <option [value]="10">Octubre</option>
                  <option [value]="11">Noviembre</option>
                  <option [value]="12">Diciembre</option>
                </select>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label for="cardExpirationYear" class="label-form-style">Año</label>
                <select class="p-dropdown" id="cardExpirationYear" formControlName="cardExpirationYear">
                  <option selected="true" [value]="2024">2024</option>
                  <option [value]="2025">2025</option>
                  <option [value]="2026">2026</option>
                  <option [value]="2027">2027</option>
                  <option [value]="2028">2028</option>
                  <option [value]="2029">2029</option>
                  <option [value]="2030">2030</option>
                  <option [value]="2031">2031</option>
                  <option [value]="2032">2032</option>
                  <option [value]="2033">2033</option>
                  <option [value]="2034">2034</option>
                </select>
              </div>

            </div>
            <div class="col-4">
              <div class="form-group">
                <label for="cardCvv" class="label-form-style">CVV</label>
                <input type="text" class="form-control input-form-full-space" formControlName="cardCvv" id="cardCvv">
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-2">
              <img [attr.alt]="paymentMethodVisaalt" [attr.src]="paymentMethodVisasrc"
                class="quote-step8-payment-method-visa" />
            </div>
            <div class="col-2">
              <img [attr.alt]="paymentMethodMastercardalt" [attr.src]="paymentMethodMastercardsrc"
                class="quote-step8-payment-method-mastercard" />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <button type="button" (click)="pay()" [disabled]="isPayButtonDisabled"
                  class="btn btn-primary continue-btn-steps py-3">Pagar</button>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="paymentStatus == 1">
            <div class="col-12">
              <div class="alert alert-success alert-dismissible fade show" role="alert">
                <strong>Pago realizado.</strong> Número de autorización: <strong>{{paymentAuthNumber}}</strong>.
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-12 d-flex justify-content-between">
              <button (click)="prevStep()" class="btn btn-primary back-btn-steps py-3">&lt; Paso anterior</button>
              <button (click)="nextStep()" [disabled]=""
                class="btn btn-primary continue-btn-steps-two py-3 px-3">Continuar</button>
            </div>
          </div>

        </form>


      </div>
    </div> -->
    <!-- addd new code -->
    <div class="plandetails payment-info-section">
      <!-- Policy Details -->
      <div class="policy-details-toggle">
        <p (click)="toggleSection()" class="clickable-text">
          <span class="font-weight-bold">Detalles de Poliza</span>
          <span>Desplegar</span>
        </p>
        <div [class.show]="isSectionVisible" class="toggle-section">
          <div class="policy-details policy-details--v2">

            <h4>Tu viaje</h4>
            <div class="policy-info">
              <div class="policy-info-box">
                <span class="policy-info-box-title policy-target-blue"><small>Destino</small>{{geographicalDestination}}</span>
                <a (click)="jumpTpStep(1)" class="info-box-edit" title="Cambiar destino" aria-label="Cambiar destino">
                  <img src="/assets/external/edit.png" alt="">
                </a>
              </div>
              <div class="policy-info-box">
                <span class="policy-info-box-title policy-user-blue"><small>Viajeros</small>{{personCount}} {{personCount === 1 ? 'persona' : 'personas'}}</span>
                <a (click)="jumpTpStep(2)" class="info-box-edit" title="Cambiar viajeros" aria-label="Cambiar viajeros">
                  <img src="/assets/external/edit.png" alt="">
                </a>
              </div>
              <div class="policy-info-box">
                <span class="policy-info-box-title policy-date-blue"><small>Fechas</small>{{tripRangeLabel || (durationInDays + ' días')}}<em *ngIf="tripRangeLabel">{{durationInDays}} {{durationInDays === 1 ? 'día' : 'días'}}</em></span>
                <a (click)="jumpTpStep(1)" class="info-box-edit" title="Cambiar fechas" aria-label="Cambiar fechas">
                  <img src="/assets/external/edit.png" alt="">
                </a>
              </div>
            </div>
            <!-- <div class="button-box">
              <button type="button" [disabled]="isBusy" class="btn btn-primary" data-bs-toggle="modal"
                data-bs-target="#sendQuoteByEmailModal">Enviar Correo</button>
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="policy-details m-none">
        <h4>Policy Details</h4>
        <div class="policy-info">
          <div class="policy-info-box">
            <span class="policy-info-box-title policy-target-blue">Destino North America</span>
            <a href="javascript:void(0)" class="info-box-edit">
              <img src="/assets/external/edit.png" alt="edit">
            </a>
          </div>
          <div class="policy-info-box">
            <span class="policy-info-box-title policy-user-blue">2 Personas</span>
            <a href="javascript:void(0)" class="info-box-edit">
              <img src="/assets/external/edit.png" alt="edit">
            </a>
          </div>
          <div class="policy-info-box">
            <span class="policy-info-box-title policy-date-blue">6 días</span>
            <a href="javascript:void(0)" class="info-box-edit">
              <img src="/assets/external/edit.png" alt="edit">
            </a>
          </div>
        </div>
        <div class="button-box">
          <button class="btn btn-primary">Enviar Correo</button>
        </div>
      </div> -->
      <!-- primary Update -->
      <div class="planupadte-box primary-plan payment-page">
        <h4 class="mobile-none">{{ maximumCoverage[planId].planName }}</h4>
        <div class="web-none d-flex justify-content-between">
          <h4>Total Plan Premium</h4>
          <h4>{{ quoteService.quoteRateModel?.price | currency:'USD':'symbol' }}</h4>
        </div>
        <div class="plan-price">
          <h2 class="mobile-none">{{ quoteService.quoteRateModel?.price | currency:'USD':'symbol' }}</h2>
          <span class="blue-text mobile-none">Cobertura por {{ maximumCoverage[planId].name}}</span>
          <span class="gray-text">Precio expresado en dólares de los EE.UU.</span>
          <div class="plan-price-info">
            <div class="plan-price-info-box">
              <span class="plan-price-info-box-title">Coberturas Opcionales Seleccionadas</span>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="(quoteService.quoteRateModel.preexistingMedicalConditions.value == true && quoteService.quoteRateModel.preexistingMedicalConditions.ownerRate > 0) || (quoteService.quoteRateModel.preexistingMedicalConditions.value == true && quoteService.quoteRateModel.preexistingMedicalConditions.dependentsRate > 0)">
                <span>Preexistencias</span>
                <span class="text-bold">
                  <span *ngIf="quoteService.quoteRateModel.preexistingMedicalConditions.value == false"  class="text-center">
                    No
                  </span>
                  <span
                  class="text-center"
                    *ngIf="quoteService.quoteRateModel.preexistingMedicalConditions.value == true && quoteService.quoteRateModel.preexistingMedicalConditions.ownerRate > 0">
                    Titular
                  </span>
                  <span
                    *ngIf="quoteService.quoteRateModel.preexistingMedicalConditions.value == true && quoteService.quoteRateModel.preexistingMedicalConditions.dependentsRate > 0"
                    class="text-center">

                    Dep.{{quoteService.quoteRateModel.preexistingMedicalConditions.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="quoteService.quoteRateModel.preexistingMedicalConditions.value == false" class="text-right">
                    + {{0 | currency:'USD':'symbol' }}
                  </span>
                  <span
                  class="text-right"
                    *ngIf="quoteService.quoteRateModel.preexistingMedicalConditions.value == true && quoteService.quoteRateModel.preexistingMedicalConditions.ownerRate > 0">
                    + {{quoteService.quoteRateModel.preexistingMedicalConditions.ownerRate | currency:'USD':'symbol'}}
                  </span>
                  <span
                  class="text-right"
                    *ngIf="quoteService.quoteRateModel.preexistingMedicalConditions.value == true && quoteService.quoteRateModel.preexistingMedicalConditions.dependentsRate > 0">

                    + {{quoteService.quoteRateModel.preexistingMedicalConditions.dependentsRate | currency:'USD':'symbol'}}
                  </span>
                </span>
              </div>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="(quoteService.quoteRateModel.sportPractice.value == true && quoteService.quoteRateModel.sportPractice.ownerRate > 0) || (quoteService.quoteRateModel.sportPractice.value == true && quoteService.quoteRateModel.sportPractice.dependentsRate > 0)">
                <span >Deportes</span>
                <span class="text-bold text-center">
                  <span *ngIf="quoteService.quoteRateModel.sportPractice.value == false" class="text-center">
                    No
                  </span>
                  <span
                  class="text-center"
                    *ngIf="quoteService.quoteRateModel.sportPractice.value == true && quoteService.quoteRateModel.sportPractice.ownerRate > 0">
                    Titular
                  </span>
                  <span
                  class="text-center"
                    *ngIf="quoteService.quoteRateModel.sportPractice.value == true && quoteService.quoteRateModel.sportPractice.dependentsRate > 0">

                    Dep.{{quoteService.quoteRateModel.sportPractice.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="quoteService.quoteRateModel.sportPractice.value == false" class="text-right">
                    + {{0 | currency:'USD':'symbol' }}
                  </span>
                  <span
                    *ngIf="quoteService.quoteRateModel.sportPractice.value == true && quoteService.quoteRateModel.sportPractice.ownerRate > 0"
                    class="text-right">
                    + {{quoteService.quoteRateModel.sportPractice.ownerRate | currency:'USD':'symbol' }}
                  </span>
                  <span
                    *ngIf="quoteService.quoteRateModel.sportPractice.value == true && quoteService.quoteRateModel.sportPractice.dependentsRate > 0"
                    class="text-right">

                    + {{quoteService.quoteRateModel.sportPractice.dependentsRate | currency:'USD':'symbol' }}
                  </span>
                </span>
              </div>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="quoteService.quoteRateModel.cancellationDueToCatastrophicTrip.rate != 0">
                <span>Cancelación</span>
                <span class="text-bold text-center">{{selectedCancelTravel.name}}</span>
                <span class="text-right">+ {{quoteService.quoteRateModel.cancellationDueToCatastrophicTrip.rate ?? 0 |
                  currency:'USD':'symbol'}}</span>
              </div>
              <!-- <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="quoteService.quoteRateModel.maxCoverage.ownerRate > 0 || quoteService.quoteRateModel.maxCoverage.dependentsRate > 0">
                <span>Cobertura Máxima</span>
                <span class="text-bold">
                  <span *ngIf="quoteService.quoteRateModel.maxCoverage.ownerRate > 0" class=" text-center">
                    Titular
                  </span>
                  <span *ngIf="quoteService.quoteRateModel.maxCoverage.dependentsRate > 0"  class=" text-center">

                    Dep.{{quoteService.quoteRateModel.maxCoverage.applicableDependentsCount}}
                  </span>
                </span>
                <span class=" text-right">
                  <span *ngIf="quoteService.quoteRateModel.maxCoverage.ownerRate > 0" class="text-right">
                    + {{quoteService.quoteRateModel.maxCoverage.ownerRate | currency:'USD':'symbol' }}
                  </span>
                  <span *ngIf="quoteService.quoteRateModel.maxCoverage.dependentsRate > 0" class="text-right">

                    + {{quoteService.quoteRateModel.maxCoverage.dependentsRate | currency:'USD':'symbol' }}
                  </span>
                </span>
              </div> -->
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="(quoteService.quoteRateModel.futureMom.value == true && quoteService.quoteRateModel.futureMom.ownerRate > 0 || quoteService.quoteRateModel.futureMom.value == true && quoteService.quoteRateModel.futureMom.dependentsRate > 0)">
                <span>Futura Mamá</span>
                <span class="text-bold">
                  <span *ngIf="quoteService.quoteRateModel.futureMom.value == false"  class="text-center">
                    No
                  </span>
                  <span
                  class="text-center"
                    *ngIf="quoteService.quoteRateModel.futureMom.value == true && quoteService.quoteRateModel.futureMom.ownerRate > 0">
                    Titular
                  </span>
                  <span
                  class="text-center"
                    *ngIf="quoteService.quoteRateModel.futureMom.value == true && quoteService.quoteRateModel.futureMom.dependentsRate > 0">

                    Dep. {{quoteService.quoteRateModel.futureMom.applicableDependentsCount}}
                  </span>
                </span>
                <span>
                  <span *ngIf="quoteService.quoteRateModel.futureMom.value == false" class="text-right">
                    + {{0 | currency:'USD':'symbol' }}
                  </span>
                  <span
                    *ngIf="quoteService.quoteRateModel.futureMom.value == true && quoteService.quoteRateModel.futureMom.ownerRate > 0"
                    class="text-right">
                    + {{quoteService.quoteRateModel.futureMom.ownerRate | currency:'USD':'symbol' }}
                  </span>
                  <span
                    *ngIf="quoteService.quoteRateModel.futureMom.value == true && quoteService.quoteRateModel.futureMom.dependentsRate > 0"
                    class="text-right">

                    + {{quoteService.quoteRateModel.futureMom.dependentsRate | currency:'USD':'symbol' }}
                  </span>
                </span>
              </div>
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="(quoteService.quoteRateModel.pets.rate != 0)">
                <span>Mascotas</span>
                <span class="text-bold text-center">{{selectedAssistPet.name}}</span>
                <span class="text-right">+ {{quoteService.quoteRateModel.pets.rate ?? 0 | currency:'USD':'symbol'}}</span>
              </div>              
              <div class="plan-price-value-table"
                [class.plan-price-value-table-active]="quoteService.quoteRateModel.legalVipAssistance.value ">
                <span>Asistencia Legal VIP</span>
                <span class="text-bold text-center">{{selectedLegalAssist.name}}</span>
                <span class="text-right"> + {{quoteService.quoteRateModel.legalVipAssistance.rate ?? 0 | currency:'USD':'symbol'}}</span>
              </div>
               <button type="button" class="btn btn-primary sendQuoteEmail" data-bs-toggle="modal"
                data-bs-target="#sendQuoteByEmailModal">Enviar Correo</button>
            </div>
          </div>

        </div>
      </div>
      <div class="payment-info">
        <form [formGroup]="stepThreeForm" novalidate class="p-5 form-general-style">
          <div class="p-3 background-effect mb-16px">
            <span style="font-size: 11px;">Por favor, confirme los datos del comprador. Recuerde que estos pueden ser
              distintos a los del asegurado.</span>
          </div>
          <div class="row formControlRow mb-16px">
            <div class="formControlContainer col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <app-input-field [formGroup]="stepThreeForm" controlName="applicantName" id="firstName" label="Nombres"
              [submitted]="submitted"
                 errorMessage="Nombres requerido"></app-input-field>
            </div>
            <div class="formControlContainer col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pl-lg-0">
              <app-input-field [formGroup]="stepThreeForm" controlName="applicantLastName" id="lastName"
              [submitted]="submitted"
                label="Apellidos"  errorMessage="Apellidos requerido"></app-input-field>
            </div>
          </div>
          <div class="row formControlRow phone-number-row mb-16px">
            <div class="formControlContainer col-md-6 col-5 m-order-2">
              <app-dropdown [formGroup]="stepThreeForm" [options]="countries" formControlName="phoneCode" label="Código País"
              [submitted]="submitted"
              errorMessage="Código Area requerido"
                icon="/assets/external/localization-vector.svg">
                <ng-template #optionTemplate let-item>
                  <div class="d-flex align-items-center">
                    <img *ngIf="item?.flag" [src]="item.flag" class="flag-icon mr-2" width="20" alt="{{ item?.name }}">
                    <span>{{ item?.code }} {{ item?.phoneCode ? ' (' + item?.phoneCode + ')' : '' }}</span>
                  </div>
                </ng-template>
              </app-dropdown>
            </div>
            <div class="formControlContainer col-md-6 col-7 m-order-3">
              <app-input-field [formGroup]="stepThreeForm" controlName="applicantPhone" id="phoneNumber"
              [submitted]="submitted"
                label="Telefono"  errorMessage="Código Area/Telefono requerido"></app-input-field>
            </div>
          </div>
          <div class="row formControlRow mb-16px">
            <div class="col-12 m-order-1">
              <app-input-field [formGroup]="stepThreeForm" controlName="applicantEmail" id="email"
              [submitted]="submitted"
                label="Correo Electrónico" 
                errorMessage="Correo Electrónico requerido"></app-input-field>
            </div>
          </div>
          </form>
        <form [formGroup]="stepSevenForm" novalidate class="mt-4 p-5 form-general-style card-form" style="z-index: 8;">
          <div class="row mb-16px">
            <div class="col-12 mb-16px">
              <app-input-field [formGroup]="stepSevenForm" controlName="cardHolderName" id="cardHolderName"
              [submitted]="submitted"
              minMaxErrorMessage="Se requieren dos personajes principales"
                label="Nombre del Comprador" 
                errorMessage="Nombre del Comprador requerido"></app-input-field>

            </div>
            <div class="col-12">
              <app-input-field [formGroup]="stepSevenForm" controlName="cardNumber" id="cardNumber"
              [submitted]="submitted"
                minMaxErrorMessage="El número no es válido"
                label="Número de tarjeta" 
                errorMessage="Número de tarjeta requerido"></app-input-field>
            </div>
          </div>
          <div class="row formControlRow mb-16px">
            <div class=" col-12 col-sm-12 col-md-12">
              <app-dropdown [formGroup]="stepSevenForm" [options]="countries" formControlName="countrie"
                controlName="countrie" optionSelected="stepSevenForm.controls['countrie'].value" label="Pais"
                [submitted]="submitted"
                icon="/assets/external/localization-vector.svg" errorMessage="Pais requerido" >
              </app-dropdown>
            </div>
            
          </div>
          <div class="form-group ">
            <div class="row date formControlRow mb-16px">
              <!-- <div class="dateFormControlContainer col">
                <app-dropdown [formGroup]="stepSevenForm" [options]="days" formControlName="day" controlName="cardExpirationDay"
                  optionSelected="stepSevenForm.controls['cardExpirationDay'].value" label="Día"
                  icon="/assets/external/localization-vector.svg" errorMessage="Día requerido" ></app-dropdown>
              </div> -->
              <div class="formControlContainer col">
              <app-input-field [formGroup]="stepSevenForm" controlName="cardCvv" id="cardCvv" label="CVV"
              [submitted]="submitted"
                minMaxErrorMessage="El CVV no es valido"
                 errorMessage="CVV requerido" ></app-input-field>
            </div>
              <div class="dateFormControlContainer col">
                <app-dropdown [formGroup]="stepSevenForm" [options]="filteredMonths" formControlName="cardExpirationMonth"
                  controlName="cardExpirationMonth" optionSelected="stepSevenForm.controls['cardExpirationMonth'].value"
                  label="Mes" icon="/assets/external/localization-vector.svg" errorMessage="Mes requerido"
                  [submitted]="submitted"
                  ></app-dropdown>
              </div>
              <div class="dateFormControlContainer col">
                <app-dropdown [formGroup]="stepSevenForm" [options]="years" formControlName="cardExpirationYear"
                  controlName="cardExpirationYear" optionSelected="stepSevenForm.controls['cardExpirationYear'].value"
                  label="Año" icon="/assets/external/localization-vector.svg" errorMessage="Año requerido"
                  [submitted]="submitted"
                  ></app-dropdown>
              </div>

            </div>
          </div>
          <div class="payment-card" aria-label="Tarjetas aceptadas">
            <img [attr.src]="paymentMethodMastercardsrc" alt="Mastercard" width="48" height="33">
            <img [attr.src]="paymentMethodVisasrc" alt="Visa" width="49" height="33">
          </div>
          <div class="terms-accept" id="termsAcceptBox" [class.terms-accept--alert]="termsAlert">
            <input type="checkbox" id="termsAccept" [checked]="istrumsAcsspted" (change)="toggleAgreement($event)">
            <label for="termsAccept">He leído y acepto los <button type="button" id="openExampleModalCenter" class="terms-accept__link" data-toggle="modal" data-target="#exampleModalCenter">Términos y Condiciones</button> y la Política de Cancelación y Devolución.</label>
          </div>
          <div class="button-box mt-4 ">
            <button type="button" (click)="pay()" class="btn btn-primary" [class.btn--off]="!istrumsAcsspted"
              [attr.aria-disabled]="!istrumsAcsspted">{{loading ? 'Cargando...' : 'Pagar'}}</button>
          </div>
          <p class="terms-help" *ngIf="!istrumsAcsspted" [class.terms-help--bad]="termsAlert">{{ termsAlert ? 'Marca la casilla para poder pagar.' : 'Acepta los términos para habilitar el pago.' }}</p>
          <p class="text-danger text-center mt-2 pay-error-message " *ngIf="submitted && (!stepThreeForm.valid || !stepSevenForm.valid)">Faltan algunos campos, por favor revise la información de contacto/pago</p>
          <div class="pay-back"><a href="javascript:void(0)" class="back-link" (click)="prevStep()">&lt; Volver a los planes</a></div>
          


          <!-- <div class="row">
            <div class="col-12 d-flex justify-content-between">
              <button (click)="prevStep()" class="btn btn-primary back-btn-steps py-3">&lt; Paso anterior</button>
              <button (click)="nextStep()" [disabled]=""
                class="btn btn-primary continue-btn-steps-two py-3 px-3">Continuar</button>
            </div>
          </div> -->
          <!-- <button (click)="nextStep()"
                class="btn btn-primary continue-btn-steps-two py-3 px-3">Continuar</button> -->
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="sendpaymentModal" tabindex="-1" aria-labelledby="sendpaymentModal" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered send-quote-modal">
    <div class="modal-content">
      <div class="modal-body">
          <h5 class="modal-title" id="exampleModalLabel">Procesando Compra</h5>
          <img src="/assets/img/loading_logo.gif" alt="Blue Assist" class="loading-logo">
      </div>
    </div>
  </div>
</div>
 <button type="button" id="sendpaymentModalToggle" class="btn btn-primary sendpaymentModal" data-bs-toggle="modal"
                data-bs-target="#sendpaymentModal" style="display: none;">Enviar Correo</button>
<div class="modal fade" id="sendQuoteByEmailModal" tabindex="-1" aria-labelledby="sendQuoteByEmailModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered send-quote-modal">
    <div class="modal-content">
      <div class="modal-body">
<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
  <path d="M14.4995 16.1911L8.57865 22.112C8.35712 22.3335 8.07517 22.4443 7.73281 22.4443C7.39045 22.4443 7.10851 22.3335 6.88698 22.112C6.66545 21.8905 6.55469 21.6085 6.55469 21.2661C6.55469 20.9238 6.66545 20.6418 6.88698 20.4203L12.8078 14.4995L6.88698 8.57865C6.66545 8.35712 6.55469 8.07517 6.55469 7.73281C6.55469 7.39045 6.66545 7.10851 6.88698 6.88698C7.10851 6.66545 7.39045 6.55469 7.73281 6.55469C8.07517 6.55469 8.35712 6.66545 8.57865 6.88698L14.4995 12.8078L20.4203 6.88698C20.6418 6.66545 20.9238 6.55469 21.2661 6.55469C21.6085 6.55469 21.8905 6.66545 22.112 6.88698C22.3335 7.10851 22.4443 7.39045 22.4443 7.73281C22.4443 8.07517 22.3335 8.35712 22.112 8.57865L16.1911 14.4995L22.112 20.4203C22.3335 20.6418 22.4443 20.9238 22.4443 21.2661C22.4443 21.6085 22.3335 21.8905 22.112 22.112C21.8905 22.3335 21.6085 22.4443 21.2661 22.4443C20.9238 22.4443 20.6418 22.3335 20.4203 22.112L14.4995 16.1911Z" fill="#2828E0"/>
</svg>
          </button>
        <div *ngIf="!emailSendingStatus || emailSendingStatus == 0">
              
          <h5 class="modal-title" id="exampleModalLabel">Envía tu cotización por correo</h5>
          
            <p>
              Puede ingresar varios correos electrónicos separados por coma (,) o punto y coma (;) 
            </p>
          <form [formGroup]="sendQuoteByEmailForm"  class="form-general-style">
            <div class="form-group">
              <app-input-field [formGroup]="sendQuoteByEmailForm" controlName="optionalRecipients" id="optionalRecipients" label="Correo Electrónico"

                 errorMessage="Correo Electrónico requerido" ></app-input-field>
              <button type="button" class="btn btn-primary send-email-button" (click)="sendEmail()">Enviar</button>
            </div>
          </form>
        </div>

        <div  *ngIf="emailSendingStatus == 1">
          <h5 class="modal-title" id="exampleModalLabel">Enviando Cotización</h5>

          <img src="/assets/img/loading_logo.gif" alt="Blue Assist" class="loading-logo">
        </div>

        <div  *ngIf="emailSendingStatus == 2">
          <h5 class="modal-title" id="exampleModalLabel">Cotización Enviada</h5>

          <img src="/assets/img/big-logo.png" alt="Blue Assist" class="loading-logo loading-active">
        </div>

        <div  *ngIf="emailSendingStatus == 3">
             <h5 class="modal-title" id="exampleModalLabel">Error al Enviar la Cotización </h5>
            <div class="alert alert-danger" role="alert" style="margin-top: 20px;">
              <strong>Correo no enviado.</strong> Por favor, intente nuevamente más tarde.
            </div>
         
        </div>

      </div>
     
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade aceptar-section" id="exampleModalCenter" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <p class="title-modal">Los Términos y Condiciones deben ser leidos y aceptados para poder continuar.</p>
        <div class="aceptar-modal">
          <p class="font-weight-bold">POLITICA DE CANCELACION Y DEVOLUCION</p>
          <p><span class="font-weight-bold">REQUISITOS DE LA INFORMACION:</span> La tramitación de una tarjeta de crédito requiere de la adquisición de la información pertinente, incluyendo el número de la tarjeta de crédito, fecha de expiración, nombre y el código CVV2, según aparece en la tarjeta de crédito. Información adicional podría incluir; pero no taxativamente la dirección de facturación de la tarjeta de crédito, un correo electrónico válido y número de teléfono del comprador, y la exención del impuesto de venta, cuandoaplique.</p>
          <p><span class="font-weight-bold">PROTECCION DE PRIVACIDAD:</span> En el momento de la compra y motivos de seguridad, un empleado administrativo de Blue Assist podrá adquirir por teléfono la información requerida para procesarla tarjeta de crédito. Para su protección, la información no podrá ser transmitida ni será aceptada por otros métodos de transmisión como son el correo electrónico o facsímil. Blue Assist tomara todos los pasos necesarios para proteger la información personal de los usuarios. Para el propósito de esta cláusula “información personal” deberá definirse como la información adquirida en el momento que se procesa la tarjeta de crédito.</p>
          <p><span class="font-weight-bold">CONFIRMACION DE LA TARJETA DE CREDITO: </span> Toda la información requerida previamente será confirmada por correo electrónico durante el proceso de confirmación de la orden, con la excepción del código CVV2, donde se utiliza únicamente los últimos cuatro dígitos de la tarjeta de crédito y cualquier otra información pertinente, según provista en el momento de adquirir la información por teléfono.
          </p>
          <p><span class="font-weight-bold">ENTREGA DE MERCANCIA Y SERVICIOS:</span> La entrega de servicios que son remunerados con pagos por tarjeta de crédito estará sujeta al recibo
          de confirmación del pago total bajo la única discreción de Blue Assist. El periodo de confirmación
          normal fluctúa de 2 a 4 días laborables.</p>
          <p><span class="font-weight-bold">TERMINOS Y LIMITACIONES DE LA TRANSACCCION:</span> Blue Assist acepta la responsabilidad en todo aspecto relacionados con la transacción incluyendo la
          venta de los servicios ofrecidos en este sitio-web, servicios al cliente, apoyo, resolución de
          disputas. Al utilizar su tarjeta de crédito para pagar por sus servicios, usted confirma ser el
          titular de la tarjeta utilizada. Todo titular de tarjeta de crédito está sujeto a chequeos de
          validación y autorización por la entidad emisora de la tarjeta y nosotros no estamos obligados a
          informarle la razón de cualquier rechazo. Blue Assist no admite responsabilidad alguna de parte de la
          entidad emisora, ni por cargos impuestos en su tarjeta como resultado del procesamiento de su pago, en
          cumplimiento con su instrucción. Además, nosotros no seremos responsables por cualquier pérdida que
          usted pueda incurrir al trasmitir información a Blue Assist por enlace (link) de internet o por correo
          electrónico. Blue Assist no acepta responsabilidad alguna por pérdidas, parcial o total, y serán de su
          única responsabilidad.</p>
          <p><span class="font-weight-bold">CANCELACION Y DEVOLUCION:</span> Si usted cambia de parecer sobre la compra de nuestros servicios y cancela, al enviarnos un correo
          electrónico a support#&64blueassist.biz, con más de 72 horas previas a la fecha de salida
          registrada de su viaje, nosotros le devolveremos el costo menos el 20% del precio total o un mínimo de
          US $20.00, la cantidad que sea mayor, e impuestos, si alguno. La devolución será realizada por el
          mismo método de pago que usted utilizo al comprar nuestros servicios. Nosotros no emitiremos
          devoluciones, cuando la solicitud de cancelación sea recibida por nosotros con 72 horas o meno previas
          a la fecha de salida registrada de su viaje.</p>
          <p class="font-weight-bold">TERMINOS Y CONDICIONES DE UTILIZACION</p>
          <p>
            <span class="font-weight-bold">BLUEASSIST TRAVEL ASSIST</span>
            junto con sus subsidiarias y afiliadas, (“Blue Assist”) provee la información y servicios en su Página
            Web Global (“Sitio”) bajo los siguientes términos y condiciones. Al accesar o utilizar este Sitio,
            usted (“Usuario”) acepta todos los términos y condiciones.
          </p>
          <p>
            <span class="font-weight-bold">LEYES Y REGULACIONES:</span>
            El acceso y uso de este Sitio está sujeto a todas leyes y regulaciones aplicables. El Usuario acuerda
            no utilizar este Sitio de forma alguna que viole estas reglas y regulaciones.
          </p>
          <p>
            <span class="font-weight-bold">DERECHOS DE AUTOR Y MARCA REGISTRADA:</span>
            La información disponible en o a través de este Sitio es propiedad de Blue Assist, o sus licenciantes, y
            está protegida por las leyes de los Derechos de Autor y Marca Registrada. Los Usuarios no pueden
            modificar, copiar, distribuir, transmitir, publicar, vender, licenciar, crear escritos derivados de, o
            de ninguna otra forma utilizar cualquier información disponible en o a través de este Sitio para uso
            comercial. Los Usuarios no pueden utilizar la marca registrada, logos y marcas de servicios (“Marcas”)
            incluyendo, taxativamente el uso de “enlaces clave” (hot links) o “portales registrados” (meta tags)
            en otras páginas o sitios en la Página Web Global sin el previo consentimiento escrito de Blue Assist.
          </p>
          <p>
            <span class="font-weight-bold">INOBSERVANCIAS:</span>
            El Usuario acuerda no modificar, mover, añadir a, eliminar o de otra manera infringir la información
            comprendida en este Sitio. El Usuario también acuerda no descompilar, revertir ingeniería, desarmar, o
            ilegalmente usar o reproducir cualquier programa u otra propiedad material comprendida en este Sitio.
          </p>
          <p>
            <span class="font-weight-bold">ENLACES A OTROS SITIOS:</span>
            Este Sitio puede incluir enlaces a otros sitios-web que no están bajo el control de Blue Assist. Esto es
            hecho por conveniencia y Redbride no aprueba ni asume obligación o responsabilidad civil por el
            contenido de estos sitios.
          </p>
          <p>
            <span class="font-weight-bold">ENLACES DE OTROS SITIOS:</span>
            Blue Assist prohíbe los enlaces no autorizados a este Sitio y la aplicación de cualquier información
            aquí comprendida. Blue Assist se reserve el derecho de deshabilitar cualquier enlace o aplicación no
            autorizada. Blue Assist no aprueba ni se responsabiliza por la información comprendida en cualquier otro
            sitio-web que pueda tener enlace con este Sitio.
          </p>
          <p>
            <span class="font-weight-bold">INFORAMACION A TERCERAS PARTES:</span>
            Alguna de la información en este Sitio puede ser facilitada a terceras partes. Mientras que Blue Assist
            realiza todo esfuerzo comercialmente razonable para atestar la exactitud de la información en este
            Sitio, esto no garantiza la exactitud y compleción de cualquier información.
          </p>
          <p>
            <span class="font-weight-bold">NO GARANTIAS:</span>
            La información y documentos en este Sitio son provistos sin garantía de algún tipo, tanto expresa o
            implícita, incluyendo, sin limitación, garantías de comercialización, prácticas con particular
            propósito y no-infracción. Blue Assist no ofrece garantías ni representaciones de la exactitud y
            compleción de cualquier información en este Sitio. Blue Assist, de vez en cuando, podrá añadir, cambiar,
            o eliminar sin previo aviso, información y documentos de este Sitio. Blue Assist no acepta obligación ni
            responsabilidad civil por errores y omisiones en este Sitio. Los usuarios acceden y utilizan este
            Sitio, bajo su responsabilidad.
          </p>
          <p>
            <span class="font-weight-bold">LIMITE DE RESPONSABILIDAD:</span>
            Por ninguna circunstancia Blue Assist deberá ser responsable por daños sufridos por el Usuario,
            incluyendo cualquier incidental, especifico o daño consecuente, que derive de acceder, utilizar o
            inhabilitar el uso de este Sitio, o por cualquier infracción de seguridad asociada con la transmisión
            de información a través de internet, incluso cuando Blue Assist haya sido notificado de la posibilidad
            de dichos daños.
          </p>
          <p>
            <span class="font-weight-bold">PRIVACIDAD:</span>
            Favor de referirse al Aviso de Privacidad de Blue Assist, publicado en este Sitio.
          </p>
          <p>
            <span class="font-weight-bold">SEGURIDAD:</span>
            La seguridad de la información transmitida a través de internet no es garantizada. Blue Assist no es
            responsable por cualquier intercepción o interrupción de cualquier comunicación a través de internet o
            por cambios o perdida de datos. El Usuario es responsable por la seguridad de cualquier
            identificación, clave de seguridad o cualquier otra forma de autenticidad.
          </p>
          <p>
            <span class="font-weight-bold">TRANSMISION DE DATOS PERSONALES:</span>
            El Usuario reconoce y acepta que al proveer a Blue Assist con cualquier información personal a través de
            este Sitio, el Usuario consiente la trasmisión de dicha información a través de confines
            internacionales.
          </p>
          <p>
            <span class="font-weight-bold">ACCESO DE AREAS PROTEGIDAS:</span>
            El acceso y uso de clave de seguridad en áreas protegidas de este Sitio se encuentra restricto a
            usuarios autorizados únicamente. El acceso no-autorizado está prohibido en dichas áreas.
          </p>
            <p class="font-weight-bold">AVISO DE PRIVACIDAD</p>
          <p>
            <span class="font-weight-bold">BLUEASSIST TRAVEL ASSIST</span>
            obedece y realiza todo esfuerzo comercialmente posible para proteger su (Usuario) privacidad. Las
            normas a continuación rigen la información y práctica de privacidad nuestra en esta Página-Web
            (Sitio).
          </p>
          <p>
            <span class="font-weight-bold">USO DE INFORMACION.</span>
            Información confidencial puede ser utilizada para rastrear el número de visitantes a este Sitio. Esta
            información es únicamente para uso interno y no es compartida con terceras partes. Información
            personal identificable como es, nombre, dirección y número de identificación solo se obtiene cuando el
            Usuario la provee voluntariamente y con el único propósito de identificación. Nosotros no divulgaremos
            su información sin su permiso, excepto con el propósito de cumplir con su solicitud de información,
            productos o servicios ofrecidos en este Sitio. Nosotros no negociaremos su información sin su
            consentimiento.
          </p>
          <p>
            <span class="font-weight-bold">REQUISITO LEGAL.</span>
            Nosotros podríamos necesitar revelar su información personal confidencial cuando nos sea requerido por
            ley, como cuando sea necesario cumplir con un mandato gubernamental, procedimientos jurídicos, orden
            de la corte o cualquier otro proceso legal.
          </p>
          <p>
            <span class="font-weight-bold">OTRAS PAGINA-WEB.</span>
            Este Sitio puede tener conexiones a otros sitios-web con avisos y prácticas de privacidad diferentes.
            Nosotros no somos responsables por los avisos o prácticas de privacidad de cualquier otro sitio-web.
          </p>
          <p>
            <span class="font-weight-bold">CONFIDENCIALIDAD.</span>
            Nosotros haremos todo esfuerzo comercialmente posible para proteger la información confidencial de
            nuestros Usuarios contra daños o uso no-autorizado. El acceso a su información confidencial es
            restringido a nuestros empleados, representantes autorizados y otros que necesitan conocer de esta
            información para proveerle a usted con la información, productos y servicios que usted ha solicitado.
            Nosotros salvaguardamos los recursos tangibles, electrónicos y técnicos para proteger información
            confidencial.
          </p>
          <p>
            <span class="font-weight-bold">MODIFICACIONES</span>
            Este Aviso de Privacidad está sujeto a cambios sin previa notificación; pero cualquier cambio será
            colocado en esta página, de nuestro Sitio-web.
          </p>
          <p class="font-weight-bold">CANCELLATION AND RETURN POLICY</p>
          <p>
            <span class="font-weight-bold">INFORMATION REQUIREMENTS:</span>
            The processing of a credit card payment shall require the collection of pertinent information
            including the credit card number, expiration date, name and CVV2 code as it appears on the credit
            card. Additional required information shall include but not be limited to the credit card billing
            address, a valid email address and telephone number of the purchaser, and a valid sales tax exemption
            number when applicable.
          </p>
          <p>
            <span class="font-weight-bold">PRIVACY PROTECTION:</span>
            For security purposes, credit card processing information shall be acquired by telephone at time of
            purchase order by authorized administrative personnel of Blue Assist. Information may not be transmitted
            nor will it be accepted by other methods such as email or fax transmissions for your protection.
            Blue Assist shall take all reasonable steps to protect the personal information of users. For the
            purpose of this clause, “personal information” shall be defined as all information collected at time
            of credit card payment processing.
          </p>
          <p>
            <span class="font-weight-bold">CREDIT CARD INFORMATION CONFIRMATION:</span>
            All information required above shall be confirmed by email during the order confirmation process, with
            exception to the CVV2 Code, using only the last four digits of the credit card and all other pertinent
            information, as furnished at time of information collection on the telephone.
          </p>
          <p>
            <span class="font-weight-bold">DELIVERY OF GOODS AND SERVICES:</span>
            Delivery of Goods and Services that are remunerated by credit card payment shall be subject to
            confirmation of payment receipt in full at the sole discretion of Blue Assist. Normal confirmation
            periods for credit cards payment can range between 2 to 4 business days.
          </p>
          <p>
              <span class="font-weight-bold">TRANSACCION TERMS AND LIMITATIONS:</span>
            Blue Assist takes responsibility for all aspects relating to the transaction including sale of services
            offered on this website, customer service and support, dispute resolution. By using a credit/debit
            card to pay for your services, you confirm that the card being used is yours. All credit card holders
            are subject to validation checks and authorization by the card issuer and we are not obligated to
            inform you of the reason for any refusal. Blue Assist bears no responsible for your card issuer or bank
            charging you as a result of our processing of your credit/debit card payment in accordance with your
            instruction. Furthermore, we cannot be responsible for any losses you may incur in transmitting
            information to Blue Assist by internet link or by email. Any such loss shall not be borne, either wholly
            or in part, by Blue Assist, and shall be entirely your responsibility.
          </p>
          <p>
            <span class="font-weight-bold">CANCELLATION AND REFUND:</span>
            If you change your mind about purchasing our services and cancel, by sending us an email to
            support#&64blueassist.biz, more than 72 hours prior to the scheduled departure of your trip, we
            will refund the cost less 20% of the total price or US$20.00, whichever amount is higher, fees and
            taxes; if any. The refund will be made by the same method of payment you used to purchase of service.
            We will not issue a refund if the request for cancellation is received by us less than 72 hours prior
            to the schedule departure date of your trip.
          </p>
          <p class="font-weight-bold">UTILIZATION POLICY TERMS AND CONDITIONS</p>
          <p>
            <span class="font-weight-bold">BLUEASSIST TRAVEL ASSIST, S.A.</span>
            along with its subsidiaries and affiliates, (“Blue Assist”) provides the information and services on its
            World Wide Web site (“Site”) under the following terms and conditions. By accessing and or using this
            Site, you (“User”) accept all terms and conditions.
          </p>
          <p>
            <span class="font-weight-bold">LAW AND REGULATIONS:</span>
            Access to and use of this Site is subject to all applicable laws and regulations. User agrees not to
            use this Site in any way that violates these rules and regulations.
          </p>
          <p>
            <span class="font-weight-bold">COPYRIGHT ABD TRADEMARKS:</span> 
            The information available on or through this Site is the property of Blue Assist, or its licensors, and
            is protected by copyright, trademark or other intellectual property laws. Users may not modify copy,
            distribute, transmit, display, publish, sell, license, create derivative works or in any other way use
            any information available on or through this Site for commercial purposes. Users may not use the
            trademarks, logos and service marks (“Marks”) including, but not limited, to use as “hot links” or
            “meta tags” on other pages or sites on the World Wide Web without the prior, written consent of
            Blue Assist.
          </p>
          <p>
            <span class="font-weight-bold">TAMPERING:</span>
            User agrees not to modify, move, add to, delete or otherwise tamper with the information contained in
            this Site. User also agrees not to decompile, reverse engineer, disassemble, or unlawfully use or
            reproduce any of the software or other proprietary material contained in this Site.
          </p>
          <p>
            <span class="font-weight-bold">LINKS TO OTHER SITES:</span>
            This Site may contain links to other web sites that are not under Blue Assist’s control. This is done as
            a convenience and Blue Assist does not endorse or assumes responsibility or liability for the content of
            these sites.
          </p>
          <p>
            <span class="font-weight-bold">LINKS FROM OTHER SITES:</span>
            Blue Assist prohibits unauthorized links to the Site and the framing of any information contained
            herein. Blue Assist reserves the right to disable any authorized links or frames. Blue Assist is not
            responsible or liable for any information on other web sites that may contain a link to this Site.
          </p>
          <p>
            <span class="font-weight-bold">THIRD PARTY INFORMATION:</span>
            Some of the information on this Site may be provided to third parties. While Blue Assist makes every
            commercially reasonable effort to ensure the accuracy of the information on this Site, it does not
            warrant the accuracy or completeness of any information.
          </p>
          <p>
            <span class="font-weight-bold">NO WARRANTIES:</span>
            Information and documents provided on this Site are provided without any warranty of any kind, either
            express or implied, including without limitation, warranties or merchantability, fitness for a
            particular purpose and non-infringement. Blue Assist does not make any warranties or representations as
            to the accuracy of completeness of any information on this Site. Blue Assist, from time to time, may
            add, change or delete information and documents on this Site without notice. Blue Assist assumes no
            responsibility or liability for errors and omissions on this Site. Users access and use this Site at
            their own risk.
          </p>
          <p>
            <span class="font-weight-bold">LIIMITATION OF LIABILITY:</span>
            Under no circumstances shall Blue Assist be liable for any damages suffered by a User, including any
            incidental, special or consequential damages, that result from access, use or inability to use this
            Site, or due to any breach of security associated with the transmission of information through the
            internet, even if Blue Assist was advised of the possibility of such damages.
          </p>
          <p>
            <span class="font-weight-bold">PRIVACY:</span>
            Please refer to Blue Assist’s Privacy Statement.
          </p>
          <p>
            <span class="font-weight-bold">SECURITY:</span>
            The security of information transmitted through the internet cannot guarantee. Blue Assist is not
            responsible for any interception or interruption of any communications through the internet or for
            changes to or losses of data. User is responsible for the security of any passwords, user id or other
            forms of authentication.
          </p>
          <p>
            <span class="font-weight-bold">TRANSMISSION OF PERSONAL DATA</span>
            User acknowledges and agrees that by providing Blue Assist with any personal information through this
            Site, User is consenting to the transmission of such information across the international borders.
          </p>
          <p>
            <span class="font-weight-bold">ACCESS TO PASSWORD PROTECTED AREAS:</span>
            Access to and uses of password protected areas on this Site are restricted to authorized users only.
            Unauthorized access to such areas is prohibited.
          </p>
          <p class="font-weight-bold">PRIVACY STATEMENT</p>
          <p>
            <span class="font-weight-bold">BLUEASSIST TRAVEL ASSIST, S.A.</span>
            respects and makes every commercially reasonable effort to protect your (User) privacy. The following
            principles govern our information and privacy practices on this web-site (“Site”).
          </p>
          <p>
            <span class="font-weight-bold">USE OF INFORMATION.</span>
            Non-personal information may be used to tract the number of visitors to this Site. This information is
            strictly for international use and is not shared with third parties. Personally identifiable
            information such as name, address and identification numbers is collected only when voluntary provided
            by the User and only for the identified purposes. We will not disclose your personal information
            without your permission except for the purpose of fulfilling your request for information, products or
            services offered on this Site. We will not sell your information without your consent.
          </p>
          <p>
            <span class="font-weight-bold">LEGAL REQUIREMENT.</span>
            We may need to disclose personally identifiable information when required by law, such as when
            necessary to comply with a government mandate, judicial proceeding, court order or other legal
            process.
          </p>
          <p>
            <span class="font-weight-bold">OTHER WEBSITES.</span>
            This Site may contain links to other web sites with different privacy statements and practices. We are
            not liable or responsible for the privacy statements of any other web site.
          </p>
          <p>
            <span class="font-weight-bold">CONFIDENTIALITY.</span>
            We make every commercially reasonable effort to protect the personal information of our Users from
            loss or unauthorized use. We restrict access to your personal information to our employees and
            authorized representatives and others who need to know this information, products and services you
            have requested. We maintain physical, electronic and procedural safeguards to protect confidential
            information.
          </p>
          <p>
            <span class="font-weight-bold">MODIFICATIONS.</span>
            This Privacy Statement is subject to change without notice; but any changes will be posted on this
            page of our Site.
          </p>
        </div>
        <div class="aceptar-checkbox">
          <label class="aceptar-block">Aceptar
            <input type="checkbox" (change)="acceptFromModal($event)" [checked]="istrumsAcsspted">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Payment Error Modal Component -->
<app-error-modal 
  [errorData]="currentErrorData" 
  (actionClick)="onPaymentErrorActionClick($event)">
</app-error-modal>